import { type Response, sendGet, sendPost } from '../hooks/use-fetch'
import { type ProfessionalDevelopmentResource } from '../models/ProfessionalDevelopmentResource'
import { type CreateProfessionalDevelopmentResourceRequest, type TrackProfessionalDevelopmentResourceRequest, type UpdateProfessionalDevelopmentResourceRequest } from '../models/requestObjects/priorityOne/professionalDevelopmentResource/professionalDevelopmentResourceRequestObjects'

const baseUrl = 'ProfessionalDevelopmentResource'
export async function AddProfessionalDevelopmentResource (resource: CreateProfessionalDevelopmentResourceRequest): Promise<Response> {
  return await sendPost(`${baseUrl}/CreateProfessionalDevelopmentResource`, resource)
}

export async function UpdateProfessionalDevelopmentResource (resource: UpdateProfessionalDevelopmentResourceRequest): Promise<Response> {
  return await sendPost(`${baseUrl}/UpdateProfessionalDevelopmentResource`, resource)
}

export async function TrackProfessionalDevelopmentResource (resource: TrackProfessionalDevelopmentResourceRequest): Promise<Response> {
  return await sendPost(`${baseUrl}/TrackProfessionalDevelopmentResource`, resource)
}

export async function DeleteProfessionalDevelopmentResource (id: number, isUpdate: boolean): Promise<Response> {
  return await sendPost(`${baseUrl}/DeleteProfessionalDevelopmentResource`, { isUpdate, id })
}

export async function ClearProfessionalDevelopmentResourceTracking (id: number): Promise<Response> {
  return await sendPost(`${baseUrl}/ClearTracking`, { id })
}

export async function GetProfessionalDevelopmentResources (priorityId: number, implementationPhase: boolean): Promise<ProfessionalDevelopmentResource[]> {
  const { response } = await sendGet(`${baseUrl}?priorityId=${priorityId}&&implementationPhase=${String(implementationPhase)}`)
  return response
}
